import { parseError } from '../../../libs/parser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Context from '../../../provider';
import IconEmail from '../../../assets/hkdc/icons/EmailIcon';
import IconSettingTag from '../../../assets/hkdc/icons/SettingTagIcon';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import NotificationItemComponent from '../../../components/NotificationItemComponent';
import PageTitleContComponent from '../../../components/PageTitleContComponent';
import React, { useContext, useEffect, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

const tabs = [
  { label: 'notification.all', id: 0 },
  { label: 'notification.member', id: 1 },
  { label: 'notification.promotion', id: 2 }
];

export default function WebNotifications() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { init, dispatch, me } = useContext(Context);
  const notificationNotReadCount = useNotificationsCount();
  const [activeTabID, setActiveTabID] = useState(0);
  const [allNotifications, setAllNotifications] = useState([]);

  const fetchNotifications = async (page) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getNotifications({
        page,
        pageSize: 1000
      });

      setAllNotifications(response.list);

    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  // This page only allow logged in user
  useEffect(() => {
    if (init) {
      fetchNotifications(1);
    }
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  return (
    (
      <div className='web-notifications-page'>
        <div className="y-overflow page-content-container">
          <div className="black-block full-width">
            <PageTitleContComponent
              titleText={t('notification.title')}
              pageTitleIcon={
                <IconSettingTag
                style={{
                  width: '12.5rem',
                  height: '12.5rem'
                }}
                size="large" />
              }
            />
          </div>
          <div className="section-max-container section">
            <div className="notification-list-container">
              <div className="tabs-title-cont">
                {
                  tabs.map((tab, index) => {
                    return (
                      <div
                        key={index}
                        className={`tab-title${tab.id === activeTabID ? ' active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveTabID(tab.id);
                        }}
                      >
                        {t(tab.label)}
                      </div>
                    );
                  })
                }
              </div>
              <div className="notification-list">
                {
                  activeTabID === 0 && allNotifications.length > 0 && allNotifications.map((notification, index, arr) => {
                    return (
                      <NotificationItemComponent
                      key={index}
                      item={notification}
                      isMobile={false}
                      isLast={arr.length -1 === index}
                      />
                    );
                  })
                }
                {
                  activeTabID === 0 && allNotifications.length === 0 &&
                  <div className="none">
                    <div className="title-cont">
                      <IconEmail
                        className='icon'
                        size="large" />
                      <div className="title-text">
                        {t('none-data.notification-title')}
                      </div>
                    </div>
                    <div className="desc">
                      {t('none-data.notification-desc')}
                    </div>
                  </div>
                }
                {
                  activeTabID === 1 && allNotifications.length > 0 &&
                  allNotifications
                  .filter((item) => item.scheme?.category === "member").length > 0 &&
                  allNotifications
                  .filter((item) => item.scheme?.category === "member")
                  .map((notification, index, arr) => {
                    return (
                      <NotificationItemComponent
                      key={index}
                      item={notification}
                      isMobile={false}
                      isLast={arr.length -1 === index}
                      />
                    );
                  })
                }
                {
                  activeTabID === 1 && (allNotifications.length === 0 ||
                  allNotifications
                  .filter((item) => item.scheme?.category === "member").length === 0) &&
                  <div className="none">
                    <div className="title-cont">
                      <IconEmail
                        className='icon'
                        size="large" />
                      <div className="title-text">
                        {t('none-data.notification-title')}
                      </div>
                    </div>
                    <div className="desc">
                      {t('none-data.notification-desc')}
                    </div>
                  </div>
                }
                {
                  activeTabID === 2 && allNotifications.length > 0 &&
                  allNotifications
                  .filter((item) => item.scheme?.category === "promotion").length > 0 &&
                  allNotifications
                  .filter((item) => item.scheme?.category === "promotion")
                  .map((notification, index, arr) => {
                    return (
                      <NotificationItemComponent
                      key={index}
                      item={notification}
                      isMobile={false}
                      isLast={arr.length -1 === index}
                      />
                    );
                  })
                }
                {
                  activeTabID === 2 && (allNotifications.length === 0 ||
                  allNotifications
                  .filter((item) => item.scheme?.category === "promotion").length === 0) &&
                  <div className="none">
                    <div className="title-cont">
                      <IconEmail
                        className='icon'
                        size="large" />
                      <div className="title-text">
                        {t('none-data.notification-title')}
                      </div>
                    </div>
                    <div className="desc">
                      {t('none-data.notification-desc')}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>

          <div className="black-block full-width">
            <LogoFooterComponent />
          </div>
        </div>
      </div>
    )
  );
}